import React from "react";
import { FaMapMarkerAlt, FaClock, FaStar, FaHiking, FaCamera } from "react-icons/fa"; // Import Icons
import "./HeritageDetail.css";
import dest1 from "../../img/bhuleshwar.avif";
import dest2 from "../../img/MIT.jpg";
import dest3 from "../../img/nane-ghat.jpg";
import dest4 from "../../img/shaniwar-wada.jpg";
import dest5 from "../../img/aurangabad.jpg";
import { useEffect } from "react";

const tours = [
  {
    id: 1,
    title: "Blissful Bhuleshwar",
    description:
      "Discover the serene Bhuleshwar temple, famed for its architecture and peaceful surroundings, and soak in the rich heritage of this gem.",
    highlights: [
      { icon: <FaMapMarkerAlt />, text: "Pune" },
      { icon: <FaClock />, text: "Sunrise Views" },
      { icon: <FaCamera />, text: "Photography Paradise" },
    ],
    duration: "Half-Day Tour",
    image: dest1,
  },
  {
    id: 2,
    title: "Heritage Walk for MIT WPU",
    description:
      "A custom walk designed for MIT WPU students, exploring cultural landmarks and architectural wonders in Pune.",
    highlights: [
      { icon: <FaHiking />, text: "Walking Tour" },
      { icon: <FaMapMarkerAlt />, text: "MIT Campus" },
      { icon: <FaStar />, text: "Rated 4.8/5" },
    ],
    duration: "2 Hours",
    image: dest2,
  },
  {
    id: 3,
    title: "Nane Ghat",
    description:
      "A trek through the ancient Nane Ghat trade route, offering breathtaking views and an adventurous experience.",
    highlights: [
      { icon: <FaHiking />, text: "Trekking Spot" },
      { icon: <FaClock />, text: "6-Hour Trek" },
      { icon: <FaCamera />, text: "Scenic Views" },
    ],
    duration: "Full-Day Adventure",
    image: dest3,
  },
  {
    id: 4,
    title: "Old Pune Heritage Walk",
    description:
      "Stroll through Pune's historic gems like Shaniwar Wada, Tulshibaug, and vibrant old city bazaars.",
    highlights: [
      { icon: <FaMapMarkerAlt />, text: "Shaniwar Wada" },
      { icon: <FaClock />, text: "Morning Walk" },
      { icon: <FaStar />, text: "Highly Rated" },
    ],
    duration: "3 Hours",
    image: dest4,
  },
  {
    id: 5,
    title: "Aurangabad Heritage Tour",
    description:
      "Immerse yourself in history by visiting Ajanta & Ellora caves and Bibi Ka Maqbara in this cultural exploration.",
    highlights: [
      { icon: <FaMapMarkerAlt />, text: "Aurangabad" },
      { icon: <FaClock />, text: "Day Tour" },
      { icon: <FaCamera />, text: "Monument Photography" },
    ],
    duration: "Full-Day Tour",
    image: dest5,
  },
];
 
export default function HeritageDetail() {
    useEffect(() => {
        const handleScroll = () => {
            const cards = document.querySelectorAll('.location-card');
            cards.forEach(card => {
                const rect = card.getBoundingClientRect();
                if (rect.top < window.innerHeight - 100) {
                    card.classList.add('visible');
                }
            });
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
  return (
    <div className="heritage">
          <div className="heritage-header">
        <h1>Heritage Walks and Tours</h1>
        <p>Experience the stories and beauty of India's rich heritage.</p>
      </div>
      <div className="heritage-container">
        <div className="tour-list">
          {tours.map((tour) => (
            <div key={tour.id} className="tour-item">
              {/* Image Section */}
              <div className="tour-image-wrapper">
                <img src={tour.image} alt={tour.title} />
              </div>
              {/* Overlapping Duration Badge */}
              <div className="tour-highlight">{tour.duration}</div>
              {/* Content Section */}
              <div className="tour-content">
                <h3>{tour.title}</h3>
                <p>{tour.description}</p>
                <div className="highlights">
                  {tour.highlights.map((highlight, index) => (
                    <div key={index} className="highlight-item">
                      {highlight.icon} {highlight.text}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
